const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes in milliseconds
let inactivityTimer: NodeJS.Timeout | null = null;

// Events to track user activity
const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'click',
];

const logout = () => {
  console.log('🔒 Session expired due to inactivity');
  
  // Clear session data
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('isAuthenticated');
  
  // Redirect to login
  window.location.href = '/login';
};

const resetTimer = () => {
  // Clear existing timer
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
  }
  
  // Set new timer
  inactivityTimer = setTimeout(() => {
    logout();
  }, INACTIVITY_TIMEOUT);
};

export const initSessionManager = () => {
  console.log('✅ Session manager initialized - 30 minute timeout');

  // Set initial timer
  resetTimer();
  
  // Add event listeners for user activity
  ACTIVITY_EVENTS.forEach((event) => {
    window.addEventListener(event, resetTimer, true);
  });
};

export const destroySessionManager = () => {
  console.log('🛑 Session manager destroyed');
  
  // Clear timer
  if (inactivityTimer) {
    clearTimeout(inactivityTimer);
    inactivityTimer = null;
  }
  
  // Remove event listeners
  ACTIVITY_EVENTS.forEach((event) => {
    window.removeEventListener(event, resetTimer, true);
  });
};
